import { useCallback, useState } from 'react';
import { downloadFile } from '@pages/events/[companyId]/[clubSlug]/customers/utils';

import { getTicketDownloadStatus } from './use-get-ticket-download-status';

export type FileDownloadModalStatus = 'idle' | 'downloading' | 'not-available';

export interface FileDownloadModalProps {
  status: FileDownloadModalStatus;
  onClose: () => void;
  downloadingTitle?: string;
  downloadingDescription?: string;
}

interface UseCheckTicketDownloadReturn {
  checkAndDownload: (token: string, urlOrCallback: string | (() => void)) => Promise<void>;
  downloadModalProps: FileDownloadModalProps;
}

export const useCheckTicketDownload = (): UseCheckTicketDownloadReturn => {
  const [modalStatus, setModalStatus] = useState<FileDownloadModalStatus>('idle');

  const closeModal = useCallback(() => {
    setModalStatus('idle');
  }, []);

  const checkAndDownload = useCallback(async (token: string, urlOrCallback: string | (() => void)) => {
    setModalStatus('downloading');

    try {
      const status = await getTicketDownloadStatus(token);

      if (status.isAvailable) {
        if (typeof urlOrCallback === 'string') {
          const response = await fetch(urlOrCallback);
          if (!response.ok) {
            setModalStatus('not-available');
            return;
          }
          const blob = await response.blob();
          downloadFile(blob, 'pdf', `ticket-${token}`);
        } else {
          urlOrCallback();
        }
        setModalStatus('idle');
      } else {
        setModalStatus('not-available');
      }
    } catch {
      setModalStatus('not-available');
    }
  }, []);

  return {
    checkAndDownload,
    downloadModalProps: {
      status: modalStatus,
      onClose: closeModal,
    },
  };
};
